module.exports = __webpack_public_path__ + "static/media/alerta-gps-rojo.eb8515ab.svg";